const isPageUrl = (url) => !!url && url[0] === "/" && url[1] !== "/";
export {
  isPageUrl
};
//# sourceMappingURL=is-page-url.js.map
